import { render, staticRenderFns } from "./MyGroupsScreen.vue?vue&type=template&id=fd92c442&scoped=true&"
import script from "./MyGroupsScreen.vue?vue&type=script&lang=js&"
export * from "./MyGroupsScreen.vue?vue&type=script&lang=js&"
import style0 from "./MyGroupsScreen.vue?vue&type=style&index=0&id=fd92c442&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd92c442",
  null
  
)

export default component.exports